import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageInfo } from '../../constants/pageInfo/pageInfo.constant';
import { globalTooltipSlice } from '../../store/globalTooltip';
import { useAppDispatch } from '../store/useStore';

export const useCheckGlobalTooltip = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const globalTooltipActions = globalTooltipSlice.actions;

  useEffect(() => {
    if (location.pathname === pageInfo.downloadAppPage.path) {
      dispatch(globalTooltipActions.closeAllTooltip());
    } else {
      dispatch(globalTooltipActions.showAllTooltip());
    }
  }, [location.pathname]);
};
